import axios from "axios";

export function deleteCategory({
  id,
}) {
  const url =  `/serialnumber/api/v1/product/category/delete/${id}`;

  return new Promise((resolve, reject) => {
    axios.delete(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}